/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client';

import routes from '../shared/routes';
import AuthProvider from '../utils/AuthProvider';
import { PostInfoProvider } from '../utils/PostInfoProvider';
import client from '../api/graphql/graphqlAPI';

import NoMatch from './NoMatch';
import Body from './Body';
import BodyChildContainer from './BodyChildContainer';
import Header from './Header';


const App = () => (
  <AuthProvider>
    <ApolloProvider client={client}>
      <PostInfoProvider>
        <div className="flex flex-col items-center ">
          <Header />
          <Body>
            <BodyChildContainer>
              <Switch>
                {routes.map(({ path, exact, component: C }, index) => (
                  <Route key={index} path={path} exact={exact} render={props => <C {...props} />} />
                ))}
                <Route component={NoMatch} />
              </Switch>
            </BodyChildContainer>
          </Body>
        </div>
      </PostInfoProvider>
    </ApolloProvider>
  </AuthProvider>
);

export default App;
